import gql from 'graphql-tag';

export class FormInput {
  id: number;
  usertypeId: number;
  referenceId: number;
  referenceId2: number;
  isSystemUser: boolean;
  userName: string;
  userPassword: string;
  hasUserPassword: boolean;
  lastName: string;
  firstName: string;
  email: string;
  isActive: boolean;
  tel: string;
  mobile1: string;
  position: string;
  notes: string;
  changePasswordNextTime: boolean;
  signatureFileId: number;

  constructor() {
    this.id = undefined;
    this.usertypeId = undefined;
    this.referenceId = undefined;
    this.referenceId2 = undefined;
    this.isSystemUser = undefined;
    this.userName = undefined;
    this.userPassword = undefined;
    this.hasUserPassword = undefined;
    this.lastName = undefined;
    this.firstName = undefined;
    this.email = undefined;
    this.isActive = undefined;
    this.tel = undefined;
    this.mobile1 = undefined;
    this.position = undefined;
    this.notes = undefined;
    this.changePasswordNextTime = undefined;
    this.signatureFileId = undefined;
  }
}

export const gqlGetQuery = gql`
  query getUsers($where: String, $offset: Int, $limit: Int, $order: String) {
    getUsers(where: $where, offset: $offset, limit: $limit, order: $order) {
      data {
        id
        userName
        lastName
        firstName
        mobile1
        isSystemUser
        position
        email
        tel
        isSystemUser
        referenceId
        referenceId2
        usertypeId
        userType {
          id
          name
        }
        userview {
          id
          referenceName
          referenceId2
          referenceName2
        }
        isActive
        firstDate
        lastDate
        firstUser
        lastUser
        hasUserPassword
      }
      recordCount
    }
  }
`;

export const gqlGetByIdQuery = gql`
  query getUserById($id: Int) {
    getUserById(id: $id) {
      id
      userName
      lastName
      firstName
      email
      tel
      mobile1
      isSystemUser
      usertypeId
      position
      notes
      signatureFileId
      referenceId
      referenceId2
      isActive
      firstDate
      lastDate
      firstUser
      lastUser
      signatureFileRec {
        id
        fileName
        mimeMediaType
        s3Key
      }
      userview {
        id
        referenceName
        referenceId2
        referenceName2
      }
    }
  }
`;

export const gqlAdd = gql`
  mutation addUser($data: UserInput) {
    addUser(data: $data) {
      id
    }
  }
`;

export const gqlUpdate = gql`
  mutation updateUser($data: UserInput) {
    updateUser(data: $data) {
      id
    }
  }
`;

export const gqlDelete = gql`
  mutation deleteUser($id: Int) {
    deleteUser(id: $id)
  }
`;

export const gqlClearPassword = gql`
  mutation userClearPassword($userName: String!) {
    userClearPassword(userName: $userName)
  }
`;

export const gqlAddRecursiveContribution = gql`
  mutation addRecursiveContribution($contributorId: Int!, $year: Int!, $periodId: Int!) {
    addRecursiveContribution(contributorId: $contributorId, year: $year, periodId: $periodId)
  }
`;
